import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f7f2fa;
`;

export const CornerHeading = styled.p`
  font-size: 16px;
  color: #000000;
  font-family: DM Sans;
  font-weight: 500;
  margin-right: 10px;
  margin-top: 8px;
`;

export const PxText = styled.p`
  font-size: 14px;
  color: #565556;
  font-family: DM Sans;
  font-weight: 400;
  margin-left: 5px;
  margin-top: 15px;
`;

export const RowDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
